var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGunShotNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7148 13.333L20.7148 14.2124",
    stroke: "#A10505",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4746 13.333L22.4746 14.2124",
    stroke: "#A10505",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 16.6523L21.7268 16.6523",
    stroke: "#A10505",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.084 15.6738C11.084 14.7073 11.8675 13.9238 12.834 13.9238H23.1451C24.1116 13.9238 24.8951 14.7073 24.8951 15.6738V16.3722C24.8951 16.9231 24.6357 17.4417 24.1951 17.7722L23.103 18.5913C22.8001 18.8185 22.4316 18.9413 22.053 18.9413H21.0673H17.9895H16.7284L15.6756 22.8704C15.4255 23.804 14.4659 24.358 13.5323 24.1078L13.2103 24.0216C12.2768 23.7714 11.7228 22.8118 11.9729 21.8783L12.7603 18.9398C11.828 18.9011 11.084 18.1331 11.084 17.1913V15.6738ZM14.2684 18.1913H14.5137L13.4218 22.2665C13.3861 22.3999 13.4652 22.5369 13.5986 22.5727L13.9206 22.659C14.0539 22.6947 14.191 22.6155 14.2267 22.4822L15.3765 18.1913H15.6268L15.8278 17.4413H17.9895H21.0673H22.053C22.1071 17.4413 22.1597 17.4237 22.203 17.3913L23.2951 16.5722C23.358 16.525 23.3951 16.4509 23.3951 16.3722V15.6738C23.3951 15.5358 23.2831 15.4238 23.1451 15.4238H12.834C12.6959 15.4238 12.584 15.5358 12.584 15.6738V17.1913C12.584 17.3293 12.6959 17.4413 12.834 17.4413H13.3729H14.4694L14.2684 18.1913Z",
    fill: "#A10505"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2246 21.342C15.4414 21.4382 15.6813 21.4916 15.9336 21.4916H18.6427C19.3718 21.4916 20.0246 21.0395 20.2809 20.3569L20.861 18.8124C20.931 18.6261 20.9652 18.4284 20.9619 18.2295C20.9612 18.187 20.9589 18.145 20.9549 18.1035H16.0924L16.074 18.172H19.3786C19.4242 18.172 19.4614 18.2086 19.4621 18.2542C19.4623 18.2647 19.4605 18.2751 19.4568 18.285L18.8767 19.8295C18.8401 19.927 18.7468 19.9916 18.6427 19.9916H15.9336C15.796 19.9916 15.6843 19.8804 15.6836 19.7428L15.6831 19.631L15.2246 21.342Z",
    fill: "#A10505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGunShotNewIcon);
export default __webpack_public_path__ + "static/media/GunShotNewIcon.c58109656da0b204e21168c08bc52524.svg";
export { ForwardRef as ReactComponent };